export enum AuthEndpoints {
    AUTH_LOGIN = "auth/all",
    SESSION_TOKEN = "auth/me/token",
    AUTH_ME = "insureds/me",
    AUTH_GET_TOKEN = "auth/all/token-id",
    AUTH_GET_TOKEN_SSO = "generate-token",
    AUTH_VALIDATE_TOKEN_SSO = "validate-token",
    AUTH_REVOKE_TOKEN_SSO = "revoke-token",
}

export enum PolicyDetailEndpoints {
    Detail = "insureds/:userIdentity/insurances/:businessLine/policies/:policyId",
    Client = "insureds/:userIdentity/insurances/all/policies/:policyId/clients/:clientId",
    Insureds = "insureds/:userIdentity/insurances/all/policies/:policyId/insureds",
    Beneficiaries = "insureds/:userIdentity/insurances/all/policies/:policyId/beneficiaries",
}

export enum EpsDetailEndpoints {
    Detail = "insureds/:userIdentity/insurances/eps/plans/:policyId",
    Insureds = "insureds/:userIdentity/insurances/eps/plans/all/insureds",
}

export enum PaymentsEndpoints {
    Summary = "insureds/:userIdentity/insurances/:businessLine/policies/:policyId/payments/summaries",
}
